import assets from './productHeroAssets.json';
import type { CatalogId } from '@/lib/product-catalog-data';
import type { Language } from '@/lib/translations';

export type HeroCrop = '1x1' | '4x5' | '2x1' | '3x2';
export type ImageRole = `hero-${HeroCrop}` | 'thumb-1x1-clean' | 'og-1200x630';
const urls: Record<string, string> = assets;
export const heroSlug = (id: CatalogId) => id === 'bundle' ? 'set' : `daily-${id}`;
export const productImageUrl = (id: CatalogId, role: ImageRole, ext = 'jpg', width?: number) =>
  urls[`${heroSlug(id)}-${role}${width ? `-${width}` : ''}.${ext}`];
export const productImageSrcSet = (id: CatalogId, role: ImageRole, ext: string) =>
  [600, 1000, 1600, ...(role === 'hero-2x1' || role === 'hero-3x2' ? [2400] : [])]
    .map(w => `${productImageUrl(id, role, ext, w)} ${w}w`).join(', ');
export const cardImageRole = (language: Language): ImageRole => language === 'de' ? 'hero-1x1' : 'thumb-1x1-clean';